/* src/app/components/userandgroup/user/new-user/new-user.scss */
:host {
  display: block;
  width: 100%;
  min-height: 100%;
  color: #172033;
  font-family:
    Inter,
    "Segoe UI",
    Roboto,
    Helvetica,
    Arial,
    sans-serif;
}
.notification-content-wrapper {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: #f7f8fc;
}
.top-box-shadow {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  min-height: 58px;
  padding: 0 20px;
  background: #fff;
  border-bottom: 1px solid #e7eaf0;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.04);
}
.top-box-shadow .columns {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 !important;
}
.top-box-shadow figure {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  margin: 0 12px 0 0 !important;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.2s ease;
}
.top-box-shadow figure:hover {
  background: #f2f4f7;
}
.top-box-shadow figure i {
  color: #667085;
  font-size: 15px;
  transition: 0.2s ease;
}
.top-box-shadow figure i:hover {
  color: #253b80;
}
.top-box-shadow .is-pulled-left {
  display: flex;
  align-items: center;
  color: #172033;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
}
.top-box-shadow .is-pulled-left .has-text-link {
  margin-left: 4px;
  color: #253b80 !important;
  font-weight: 600;
}
.top-box-shadow .column.has-text-right {
  margin-left: auto;
  padding: 0 !important;
}
.top-box-shadow .button {
  min-height: 36px;
}
.desk-view {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
.desk-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}
.desk-icon button {
  margin: 0 !important;
}
.mobileViewBtn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  color: #667085;
  cursor: pointer;
  transition: 0.2s ease;
}
.mobileViewBtn:hover {
  color: #b42318;
  background: #fef3f2;
}
.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  padding: 0 14px;
  border: 1px solid #d9dee8;
  border-radius: 8px;
  background: #fff;
  color: #344054;
  font-family: inherit;
  font-size: 13px !important;
  font-weight: 600;
  box-shadow: none;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    transform 0.15s ease,
    box-shadow 0.2s ease;
}
.button:hover:not(:disabled) {
  transform: translateY(-1px);
  border-color: #c8ced8;
  background: #f8f9fb;
}
.button:active:not(:disabled) {
  transform: translateY(0);
}
.button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.button.is-link {
  border-color: #253b80;
  background: #253b80;
  color: #fff;
  box-shadow: 0 3px 8px rgba(99, 91, 255, 0.18);
}
.button.is-link:hover:not(:disabled) {
  border-color: #554de8;
  background: #554de8;
  color: #fff;
}
.button.is-outlined.is-link {
  border-color: #c9c5ff;
  background: #fff;
  color: #253b80;
  box-shadow: none;
}
.button.is-outlined.is-link:hover {
  border-color: #253b80;
  background: #f5f4ff;
  color: #554de8;
}
.button.is-dark {
  border-color: #e4e7ec;
  background: #f2f4f7;
  color: #344054;
}
.button.is-dark:hover {
  background: #eaecf0;
}
.contents {
  width: 100%;
  min-height: calc(100vh - 58px);
}
.scroll-bar {
  scrollbar-width: thin;
  scrollbar-color: #cfd4dc transparent;
}
.scroll-bar::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.scroll-bar::-webkit-scrollbar-track {
  background: transparent;
}
.scroll-bar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #cfd4dc;
}
.new-chat {
  width: 100%;
  margin: 0 !important;
}
.new-chat > .column {
  padding: 0 !important;
}
.new-chat .card {
  width: 100%;
  max-width: 980px;
  margin: 24px auto;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(16, 24, 40, 0.04), 0 1px 3px rgba(16, 24, 40, 0.03);
}
.form-style {
  padding: 26px 30px !important;
}
.form-style h4 {
  margin: 0 0 26px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eaecf0;
  color: #101828;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.35;
}
.form-style .columns {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  margin: 0 0 4px !important;
}
.form-style .columns > .column {
  width: auto !important;
  padding: 0 !important;
}
.form-style .columns:last-child {
  margin-bottom: 0 !important;
}
.form-style .column.is-12 {
  grid-column: 1/-1;
}
.profile-img {
  position: relative;
  width: 104px;
  height: 104px;
  margin: 4px auto 28px;
  border-radius: 50%;
  background: #f2f4f7;
  box-shadow: 0 0 0 5px #f8f9fc, 0 0 0 6px #e4e7ec;
}
.profile-img img {
  display: block;
  width: 104px;
  height: 104px;
  border-radius: 50%;
  object-fit: cover;
}
.profile-img .dropdown {
  position: absolute;
  right: -55px;
  bottom: -115px;
  z-index: 30;
}
.profile-img .dropdown-menu {
  min-width: 170px;
  padding: 5px;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 12px 28px rgba(16, 24, 40, 0.14);
}
.profile-img .dropdown-item {
  display: block;
  padding: 9px 11px;
  border-radius: 6px;
  color: #344054;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.profile-img .dropdown-item:hover {
  background: #f5f4ff;
  color: #253b80;
}
.img-options {
  position: absolute;
  right: -3px;
  bottom: -3px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 3px solid #fff;
  border-radius: 50%;
  background: #253b80;
  color: #fff;
  box-shadow: 0 3px 8px rgba(16, 24, 40, 0.18);
  cursor: pointer;
}
.img-options .dropdown-trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.img-options i {
  font-size: 12px;
}
.field {
  margin-bottom: 17px !important;
}
.label {
  display: block;
  margin-bottom: 7px !important;
  color: #344054 !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  line-height: 1.4;
}
.required {
  margin-left: 2px;
  color: #d92d20;
  font-size: 13px;
}
.control {
  position: relative;
}
.form-style .input,
.form-style .select select,
.form-style .textarea {
  width: 100%;
  border: 1px solid #dfe3ea;
  border-radius: 8px;
  background: #fff;
  color: #172033;
  box-shadow: none;
  font-family: inherit;
  font-size: 14px !important;
  font-weight: 400;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;
}
.form-style .input::placeholder,
.form-style .select select::placeholder,
.form-style .textarea::placeholder {
  color: #a0a8b5;
}
.form-style .input:hover,
.form-style .select select:hover,
.form-style .textarea:hover {
  border-color: #c8ced8;
}
.form-style .input:focus,
.form-style .select select:focus,
.form-style .textarea:focus {
  border-color: #253b80;
  outline: none;
  box-shadow: 0 0 0 3px rgba(99, 91, 255, 0.09);
}
.form-style .input {
  height: 42px;
  padding: 0 12px;
}
.form-style .select {
  display: block;
  width: 100%;
  height: auto;
}
.form-style .select::after {
  border-color: #98a2b3;
}
.form-style .select select {
  height: 42px;
  padding: 0 35px 0 12px;
  cursor: pointer;
}
.form-style .textarea {
  min-height: 90px;
  padding: 11px 12px;
  resize: vertical;
  line-height: 1.5;
}
form-validation {
  display: block;
  margin-top: 4px;
  font-size: 11px;
}
.form-style .display-flex {
  display: flex !important;
  align-items: center;
  justify-content: flex-end;
  margin-top: 8px !important;
  padding-top: 18px;
  border-top: 1px solid #eaecf0;
}
.form-style .has-text-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  text-align: right;
}
.mar-0-10 {
  margin: 0 !important;
}
.user-bulk-cr {
  width: 100%;
  padding: 30px 20px !important;
}
.user-bulk-cr .columns {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
}
.user-bulk-cr .column {
  padding: 0 !important;
}
.user-bulk-cr .card {
  width: 100%;
  max-width: 680px;
  margin: 30px auto;
  border: 1px solid #e4e7ec;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(16, 24, 40, 0.05);
}
.user-bulk-cr .card-content {
  padding: 30px;
}
.user-bulk-cr p {
  color: #475467;
  font-size: 14px;
  line-height: 1.6;
}
.user-bulk-cr ul {
  margin: 18px 0 24px;
  padding-left: 20px;
}
.user-bulk-cr ul li {
  margin-bottom: 11px;
  color: #667085;
  font-size: 13px;
  line-height: 1.5;
}
.user-bulk-cr ul li::marker {
  color: #253b80;
}
.user-bulk-cr .has-text-link {
  color: #253b80 !important;
  font-weight: 600;
}
.user-bulk-cr .file {
  display: inline-flex;
  margin-top: 10px;
}
.user-bulk-cr .file-cta {
  padding: 0;
  border: 0;
  background: transparent;
}
.user-bulk-cr .file-label {
  margin: 0 !important;
}
.user-bulk-cr .file-upload-nxt {
  margin-bottom: 20px;
  color: #344054;
  font-size: 14px;
  font-weight: 500;
}
.user-bulk-cr .has-text-centered > .has-text-link {
  display: inline-flex;
  max-width: 100%;
  padding: 9px 14px;
  overflow: hidden;
  border: 1px solid #dcd9ff;
  border-radius: 8px;
  background: #f5f4ff;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-bulk-cr .field.has-text-centered {
  margin-top: 24px;
}
.user-bulk-cr .field.has-text-centered .button {
  margin: 0 3px;
}
.top-align {
  width: 100%;
}
.content-height-calc {
  padding: 20px !important;
}
.content-height-calc > .column {
  padding: 0 !important;
}
.content-height-calc .message {
  margin: 0 0 16px !important;
  border: 1px solid #c9d9ff;
  border-radius: 10px;
  background: #f5f8ff;
  box-shadow: none;
}
.content-height-calc .message-body {
  padding: 12px 15px !important;
  border: 0 !important;
  color: #344054;
  font-size: 13px;
  line-height: 1.5;
}
.content-height-calc .message-body i {
  margin-right: 7px;
  color: #253b80;
}
.bulkuplTableView {
  width: 100%;
  margin: 0 !important;
  overflow: hidden;
  border: 1px solid #e4e7ec;
  border-radius: 12px;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.04);
}
.bulkuplTableView thead th {
  height: 44px;
  padding: 0 13px;
  border-bottom: 1px solid #e4e7ec;
  background: #f8f9fb;
  color: #667085;
  font-size: 11px !important;
  font-weight: 700;
  line-height: 1.3;
  text-transform: uppercase;
  letter-spacing: 0.035em;
  white-space: nowrap;
}
.bulkuplTableView tbody td {
  height: 52px;
  padding: 9px 13px;
  border-bottom: 1px solid #f0f1f4;
  color: #344054;
  font-size: 13px !important;
  line-height: 1.4;
  vertical-align: middle;
}
.bulkuplTableView tbody tr {
  transition: background 0.15s ease;
}
.bulkuplTableView tbody tr:hover {
  background: #fafbff;
}
.bulkuplTableView tbody tr:last-child td {
  border-bottom: 0;
}
.bulkuplTableView tbody td:first-child {
  color: #98a2b3;
  font-weight: 600;
}
.bulkuplTableView tbody td:nth-child(3),
.bulkuplTableView tbody td:nth-child(4) {
  color: #172033;
  font-weight: 600;
}
.bulkuplTableView .fa-trash-o {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 7px;
  background: #fef3f2;
  color: #b42318;
  font-size: 13px;
  cursor: pointer;
  transition: 0.2s ease;
}
.bulkuplTableView .fa-trash-o:hover {
  transform: translateY(-1px);
  background: #fde7e5;
}
.modal {
  z-index: 3000;
}
.modal-background {
  background: rgba(15, 23, 42, 0.55);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
}
.modal-card {
  width: min(520px, 100% - 32px);
  max-height: 80vh;
  overflow: hidden;
  border: 1px solid #e4e7ec;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 24px 60px rgba(16, 24, 40, 0.18), 0 8px 20px rgba(16, 24, 40, 0.08);
}
.modal-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 62px;
  padding: 15px 18px;
  border-bottom: 1px solid #eaecf0;
  background: #fff;
}
.modal-card-title {
  margin: 0;
  color: #172033;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.35;
}
.modal-card-body {
  padding: 18px;
  background: #f8f9fc;
}
.modal-card-body .field {
  margin-bottom: 0 !important;
}
.modal-card-body .panel-block {
  padding: 0;
  border: 0;
}
.modal-card-body .control.has-icons-left {
  position: relative;
}
.modal-card-body .input {
  width: 100%;
  height: 40px;
  padding-left: 38px;
  border: 1px solid #dfe3ea;
  border-radius: 8px;
  box-shadow: none;
  font-size: 13px;
}
.modal-card-body .input:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(99, 91, 255, 0.09);
}
.modal-card-body .icon.is-left {
  color: #98a2b3;
}
.panel-overflow {
  max-height: 390px;
  margin-top: 10px;
  overflow-y: auto;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  background: #fff;
}
.panel-overflow .panel-block {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 54px;
  padding: 8px 12px;
  border-bottom: 1px solid #f0f1f4;
  color: #344054;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.panel-overflow .panel-block:last-child {
  border-bottom: 0;
}
.panel-overflow .panel-block:hover {
  background: #fafbff;
}
.panel-overflow .panel-block.active-bg {
  background: #f5f4ff;
  color: #253b80;
}
.panel-overflow .image {
  width: 34px !important;
  height: 34px !important;
  flex: 0 0 34px;
  margin: 0 !important;
  overflow: hidden;
  border-radius: 8px;
}
.panel-overflow .image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.panel-overflow .icon-align {
  margin-left: auto;
  color: #253b80;
}
.pagination-loader {
  min-height: 40px;
}
.modal-card-foot {
  display: flex;
  justify-content: flex-end;
  padding: 13px 18px;
  border-top: 1px solid #eaecf0;
  background: #fff;
}
.modal-card-foot .column {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 0 !important;
}
@media (max-width: 1000px) {
  .form-style .columns {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .form-style .column.is-12 {
    grid-column: 1/-1;
  }
  .form-style {
    padding: 22px !important;
  }
  .new-chat .card {
    margin: 18px auto;
  }
  .bulkuplTableView {
    min-width: 900px;
  }
  .content-height-calc {
    overflow-x: auto;
  }
}
@media (max-width: 768px) {
  .top-box-shadow {
    min-height: 54px;
    padding: 0 12px;
  }
  .top-box-shadow .is-pulled-left {
    font-size: 13px;
  }
  .top-box-shadow .button {
    min-height: 34px;
    padding: 0 10px;
    font-size: 12px !important;
  }
  .new-chat .card {
    margin: 12px;
  }
  .form-style {
    padding: 18px !important;
  }
  .form-style h4 {
    margin-bottom: 20px;
    font-size: 18px;
  }
  .form-style .columns {
    grid-template-columns: 1fr;
    gap: 0;
  }
  .form-style .column.is-12 {
    grid-column: auto;
  }
  .profile-img {
    margin-bottom: 24px;
  }
  .user-bulk-cr {
    padding: 15px !important;
  }
  .user-bulk-cr .card-content {
    padding: 22px;
  }
  .content-height-calc {
    padding: 12px !important;
  }
  .modal-card {
    width: calc(100% - 20px);
    max-height: 90vh;
  }
}
@media (max-width: 480px) {
  .top-box-shadow {
    padding: 0 10px;
  }
  .top-box-shadow figure {
    margin-right: 7px !important;
  }
  .top-box-shadow .is-pulled-left {
    max-width: 180px;
    overflow: hidden;
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .top-box-shadow .desk-icon:not(.mobileViewBtn) button {
    font-size: 11px !important;
  }
  .mobileViewBtn {
    width: 30px;
    height: 30px;
  }
  .new-chat .card {
    margin: 8px;
    border-radius: 12px;
  }
  .form-style {
    padding: 15px !important;
  }
  .form-style h4 {
    font-size: 17px;
  }
  .form-style .input,
  .form-style .select select,
  .form-style .textarea {
    font-size: 13px !important;
  }
  .form-style .input,
  .form-style .select select {
    height: 40px;
  }
  .form-style .display-flex {
    padding-top: 15px;
  }
  .form-style .has-text-right {
    width: 100%;
    justify-content: stretch;
  }
  .form-style .has-text-right .button {
    flex: 1;
  }
  .label {
    font-size: 12px !important;
  }
  .user-bulk-cr .card {
    margin: 12px auto;
  }
  .user-bulk-cr .card-content {
    padding: 18px;
  }
  .user-bulk-cr ul {
    padding-left: 17px;
  }
  .user-bulk-cr ul li {
    font-size: 12px;
  }
  .modal-card-head {
    min-height: 56px;
    padding: 13px 14px;
  }
  .modal-card-title {
    font-size: 16px;
  }
  .modal-card-body {
    padding: 13px;
  }
  .modal-card-foot {
    padding: 12px 14px;
  }
}
button:focus-visible,
a:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible {
  outline: 2px solid rgba(99, 91, 255, 0.35);
  outline-offset: 2px;
}
.form-style .card-content,
.user-bulk-cr .card-content {
  background: transparent;
}
.is-size-6 {
  font-size: 15px !important;
}
.is-size-7 {
  font-size: 12px !important;
}
/*# sourceMappingURL=new-user.css.map */
